const firebaseConfigMap = {
  'sorra-dev': {
    apiKey: 'AIzaSyDuEHgfJfQOTtg_KzleQp-X0AVT-EYYXXA',
    authDomain: 'sorra-dev.firebaseapp.com',
    projectId: 'sorra-dev',
    storageBucket: 'sorra-dev.firebasestorage.app',
    messagingSenderId: '359913702573',
    appId: '1:359913702573:web:73b41ea568e94162607224',
    measurementId: 'G-QBQHJB56M0',
  },
  'sorra-4cd1f': {
    apiKey: 'AIzaSyDQQe2rbVW5FDoVQuaBbYcJ9mHtWywKwgc',
    authDomain: 'sorra-4cd1f.firebaseapp.com',
    projectId: 'sorra-4cd1f',
    storageBucket: 'sorra-4cd1f.appspot.com',
    messagingSenderId: '721789155484',
    appId: '1:721789155484:web:2263918870ba366181d559',
    measurementId: 'G-0TF99YVXL8',
  },
};

const projectId = process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'sorra-dev';
const firebaseConfig =
  firebaseConfigMap[projectId] || firebaseConfigMap['sorra-dev'];

firebaseConfig.authDomain =
  typeof window !== 'undefined' && window.location && window.location.host
    ? window.location.host
    : firebaseConfig.authDomain;

export { firebaseConfig };
